import { db } from "../firebase";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  onSnapshot,
  query,
  serverTimestamp,
  updateDoc,
  where
} from "firebase/firestore";

export const createAdminNotification = async ({
  title,
  body,
  type = "info",
  link = "",
  createdBy = ""
}) => {
  return addDoc(collection(db, "systemNotifications"), {
    audience: "admin",
    title: title || "Bildirim",
    body: body || "",
    type,
    link,
    isRead: false,
    createdBy,
    createdAt: serverTimestamp()
  });
};

export const createUserNotification = async ({
  targetUserId,
  targetUserEmail = "",
  title,
  body,
  type = "task",
  link = "",
  processId = "",
  processProjectId = "",
  createdBy = "",
  createdByUid = ""
}) => {
  if (!targetUserId) return null;

  return addDoc(collection(db, "systemNotifications"), {
    audience: "user",
    targetUserId,
    targetUserEmail,
    title: title || "Bildirim",
    body: body || "",
    type,
    link,
    processId,
    processProjectId,
    isRead: false,
    createdBy,
    createdByUid,
    createdAt: serverTimestamp()
  });
};

export const getRecentAdminNotifications = async () => {
  const snapshot = await getDocs(
    query(
      collection(db, "systemNotifications"),
      where("audience", "==", "admin")
    )
  );

  return snapshot.docs
    .map((item) => ({ id: item.id, ...item.data() }))
    .sort((a, b) => (b.createdAt?.toMillis?.() || 0) - (a.createdAt?.toMillis?.() || 0));
};

export const markNotificationRead = async (notificationId) => {
  return updateDoc(doc(db, "systemNotifications", notificationId), {
    isRead: true,
    readAt: serverTimestamp()
  });
};

export const subscribeUserNotifications = (userId, callback) => {
  if (!userId) return () => {};

  const q = query(
    collection(db, "systemNotifications"),
    where("audience", "==", "user"),
    where("targetUserId", "==", userId)
  );

  return onSnapshot(q, (snapshot) => {
    const data = snapshot.docs
      .map((item) => ({ id: item.id, ...item.data() }))
      .sort((a, b) => (b.createdAt?.toMillis?.() || 0) - (a.createdAt?.toMillis?.() || 0));

    callback(data);
  });
};

export const getUnreadAdminNotifications = getRecentAdminNotifications;
export const subscribeUnreadUserNotifications = subscribeUserNotifications;
